import React from "react";

import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
  CardHeader,
  CardActions,
  AppBar,
  Toolbar,
} from "@material-ui/core";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  footerContainer: {
    background: theme.palette.primary.dark,
    width: "100%",
    padding: theme.spacing(1),
  },
  footerCard: {
    margin: theme.spacing(1),
    background: theme.palette.primary.dark,
    boxShadow: "none",
  },
  footerCardHeader: {
    "& .MuiCardHeader-title , .MuiCardHeader-subheader": {
      color: theme.palette.primary.contrastText,
    },
  },
  footerCardContent: {
    "& .MuiTypography-root": {
      color: theme.palette.primary.contrastText,
    },
  },
  footerCardActions: {
    //  justifyContent: "center",
    "& .MuiButton-root": {
      color: theme.palette.primary.contrastText,
      textDecoration: "underline",
    },
    "& .MuiIconButton-root": {
      color: theme.palette.primary.contrastText,
    },
  },
  link: {
    color: theme.palette.primary.contrastText,
    textDecoration: "underline",
    fontFamily: "inherit",
  },
}));

const Footer = () => {
  const classes = useStyles();
  const history = useHistory();

  const footerCardAuthor = () => {
    return (
      <Card className={classes.footerCard}>
        {/* <CardHeader
          className={classes.footerCardHeader}
          title="ABOUT THE DEVELOPER"
          subheader="Piyush Kaushik"
        /> */}
        {/* <CardContent className={classes.footerCardContent}>
          <Typography variant="body1" color="textSecondary" component="p">
            Hello there, I am Piyush Kaushik <em>a.k.a kaushikDev</em> , a
            frontend web developer. Writing educational blogs on web
            development(particularly javascript and related) gives me a sense of
            satisfaction and a purpose in life. I firmly belive that free
            education is the greatest form of service and a great way of giving
            back to the community. Let's build a better world, together.
          </Typography>
        </CardContent> */}
        <CardHeader
          className={classes.footerCardHeader}
          title="MAADHYAM"
          subheader="Read. Learn. Grow."
        />
        <CardContent className={classes.footerCardContent}>
          <Typography variant="body1" color="textSecondary" component="p">
            Maadhyam started as a simple idea of sharing free web development
            tutorials in the form of text based articles/blogs which are short,
            light and easy to consume. The primary goal is to provide beginners
            a way to learn and understand the basics of web development. We, at
            Maadhyam, firmly belive that free education is the greatest form of
            service and a great way of giving back to the community. So, let's
            build a better world, together. If you have any feedback/questions,
            feel free to reach out to Piyush Kaushik(aka kaushikDev, owner and
            developer of Maadhyam) on any of the given social media contacts.
          </Typography>
        </CardContent>
        <CardActions className={classes.footerCardActions}>
          <Button onClick={() => history.push(`/maadhyam-privacy-policy`)}>
            Privacy Policy
          </Button>
        </CardActions>
      </Card>
    );
  };

  const footerCardContact = () => {
    return (
      <Card className={classes.footerCard}>
        <CardHeader
          className={classes.footerCardHeader}
          title="CONTACT ME"
          subheader="Via social media"
        />

        <CardActions className={classes.footerCardActions}>
          <IconButton
            aria-label="youtube-icon"
            href="https://www.youtube.com/channel/UC3uwdZ9kqFhz5CrDyGNsOZQ"
            target="_blank"
          >
            <YouTubeIcon />
          </IconButton>
          <IconButton
            aria-label="linkedin-icon"
            href="https://www.linkedin.com/in/piyush-kaushik-61166a22/"
            target="_blank"
          >
            <LinkedInIcon />
          </IconButton>
          <IconButton
            aria-label="twitter-icon"
            href="https://twitter.com/kaushikDev_"
            target="_blank"
          >
            <TwitterIcon />
          </IconButton>
          <IconButton
            aria-label="facebook-icon"
            href="https://www.facebook.com/connect.kaushikDev/"
            target="_blank"
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            aria-label="instagram-icon"
            href="https://www.instagram.com/kaushikdev___/?hl=en"
            target="_blank"
          >
            <InstagramIcon />
          </IconButton>
        </CardActions>
        <CardContent className={classes.footerCardContent}>
          <Typography variant="body1" color="textSecondary" component="p">
            Piyush Kaushik &copy; {new Date().getFullYear()}. All Rights
            Reserved.
          </Typography>
        </CardContent>
      </Card>
    );
  };
  return (
    <AppBar className={classes.footerContainer} position="static">
      <Toolbar>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item xs={12} md={8}>
            {footerCardAuthor()}
          </Grid>
          <Grid item xs={12} md={4}>
            {footerCardContact()}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
